import { createSelector } from '@reduxjs/toolkit';

export const selectGlobalLoading = createSelector(
    [
        (state) => state.dashboard?.loading,
        (state) => state.parent?.loading,
        (state) => state.tutor?.loading,
        (state) => state.all_lists?.loading,
        (state) => state.subAdmin?.loading,
        (state) => state.booking?.loading,
        (state) => state.couponCode?.loading,
        (state) => state.subscriptionPlan?.loading,
        (state) => state.badge?.loading,
        (state) => state.reportedBooking?.loading,
        (state) => state.review?.loading,
        (state) => state.cms?.loading,
        (state) => state.faq?.loading,
        (state) => state.notification?.loading,
        (state) => state.auth?.loading,
        (state) => state.earning?.loading,
    ],
    (...loaders) => loaders.some(Boolean)
);